import request from '@/util/request';

//获取部门
export const treeByProjectDeptId = (params, options) =>
request.get('/api/v4ward/dept/getDeptLazyTree', Object.assign({}, options, { params }));
//获取部门
export const treeByDeptId = (params, options) =>
request.get('/api/v4ward/dept/getDeptLazyTreeByDeptId', Object.assign({}, options, { params }));

//获取人员
export const getUserListByDepartmentId = (params, options) =>
request.get('/api/v4ward/user/getDeptUserList', Object.assign({}, options, { params }));
//获取人员部门

export const getUserNameListByDeptId = (params, options) =>
request.get('/api/v4ward/user/getUserNameListByDeptId', Object.assign({}, options, { params }));
//获取班组
export const getGroupList = (params, options) =>
request.get('/api/v4ward/group/getGroupList', Object.assign({}, options, { params }));

//获取人员根据班组
export const getMenberUserList = (params, options) =>
request.get('/api/v4ward/groupUser/getMenberUserList', Object.assign({}, options, { params }));

//提交处理人员信息

export const getAssembleUser = (options) =>
request.post('/api/v4ward/user/assembleUser',options );



export const deptUserList = (params, options) =>
request.get('/api/v4ward/user/dept-user-list', Object.assign({}, options, { params }));

export const getDeptUserListByDeptId = (params, options) =>
request.get('/api/v4ward/user/getDeptUserListByDeptId', Object.assign({}, options, { params }));